import type { GAEventParams, GAPageViewParams } from "@/types/analytics";

export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_ID as string;

const gaState = {
  initialized: false,
};

export const initializeAnalytics = () => {
  if (typeof window === "undefined") return false;
  if (!GA_MEASUREMENT_ID) return false;

  if (window.gtag && gaState.initialized) return true;
  if (window.gtag && !gaState.initialized) {
    window.gtag("config", GA_MEASUREMENT_ID, {
      send_page_view: true,
    });
    gaState.initialized = true;
    return true;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: true,
  });

  gaState.initialized = true;
  return true;
};

export const deInitializeAnalytics = () => {
  if (typeof window === "undefined") return;

  if (gaState.initialized) {
    const script = document.querySelector(`script[src*="googletagmanager"]`);
    if (script) {
      script.remove();
    }
    window.dataLayer = [];
    window.gtag = undefined;
    // Исправляем синтаксис
    const gaDisableKey = `ga-disable-${GA_MEASUREMENT_ID}`;
    (window as any)[gaDisableKey] = true;
    gaState.initialized = false;
  }
};

const sendPageView = (params: GAPageViewParams) => {
  if (!gaState.initialized || typeof window.gtag === "undefined") return;

  window.gtag("config", GA_MEASUREMENT_ID, {
    ...params,
    page_path: params.page_path || window.location.pathname,
    send_page_view: true,
  });
};

const sendEvent = (params: GAEventParams) => {
  if (!gaState.initialized || typeof window.gtag === "undefined") return;

  window.gtag("event", params.action, {
    event_category: params.category,
    event_label: params.label,
    value: params.value,
    currency: params.currency,
    items: params.items,
    ...params,
  });
};

export const Analytics = {
  pageview: sendPageView,
  event: sendEvent,

  login: (method: string) => {
    sendEvent({
      action: "login",
      category: "authentication",
      label: method,
    });
  },

  signup: (method: string) => {
    sendEvent({
      action: "sign_up",
      category: "authentication",
      label: method,
    });
  },

  purchase: (params: {
    value: number;
    currency?: string;
    items?: Array<{
      item_id: string;
      item_name: string;
      price: number;
      quantity: number;
    }>;
  }) => {
    sendEvent({
      action: "purchase",
      category: "ecommerce",
      value: params.value,
      currency: params.currency || "USD",
      items: params.items,
    });
  },

  pageError: (error: string, path: string) => {
    sendEvent({
      action: "error",
      category: "error",
      label: `${error} at ${path}`,
    });
  },

  featureUsage: (featureName: string) => {
    sendEvent({
      action: "feature_use",
      category: "engagement",
      label: featureName,
    });
  },
};
